export const POLL_INTERVAL = 300000 // 5min
export const SLOT_CHECK_INTERVAL = 15000 // 15 seconds
